import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import store from "../store/index.js";
const routes = [
  {
    path: `/`,
    name: "HomeView",
    component: HomeView,
    redirect: "/requests",
    meta: { title: "Главная" },
    children: [
      {
        path: "/requests",
        name: "RequestsView",
        component: () => import("../views/requests/RequestsView.vue"),
        meta: { title: "Запросы" },
        children: [
          {
            path: "/requests",
            name: "RequestsRequest",
            component: () =>
              import("../views/requests/request/RequestsRequest.vue"),
            meta: { title: "Запросы" },
          },
          {
            path: "/requests/archive",
            name: "ArchiveRequests",
            component: () =>
              import("../views/requests/request/ArchiveRequests.vue"),
            meta: { title: "Архивные запросы" },
          },
          {
            path: "/request/detail/:id",
            name: "RequestsRequestDetail",
            component: () =>
              import("../views/requests/request/RequestsRequestDetail.vue"),
            meta: { title: "Запрос" },
            children: [
              {
                path: "/requests/request/detail/basic-info/:id",
                name: "RequestsRequestDetailBasicInfo",
                component: () =>
                  import(
                    "../views/requests/request/RequestsRequestDetailBasicInfo.vue"
                  ),
                meta: { title: "Основная информация" },
              },
              {
                path: "/requests/request/detail/comments/:id",
                name: "RequestsRequestDetailComments",
                component: () =>
                  import(
                    "../views/requests/request/RequestsRequestDetailComments.vue"
                  ),
                meta: { title: "Комментарии" },
              },
              {
                path: "/requests/request/detail/document/:id",
                name: "RequestsRequestDetailDocument",
                component: () =>
                  import(
                    "../views/requests/request/RequestsRequestDetailDocument.vue"
                  ),
                meta: { title: "Документы" },
              },
              {
                path: "/requests/request/detail/price-proposals/:id",
                name: "RequestsRequestDetailPriceProposals",
                component: () =>
                  import(
                    "../views/requests/request/RequestsRequestDetailPrice.vue"
                  ),
                meta: { title: "Ценовые предложения" },
              },
            ],
          },
        ],
      },

      {
        path: "/orders",
        name: "OrdersView",
        component: () => import("../views/orders/OrdersView.vue"),
        redirect: "/orders/order",
        meta: { title: "Заказы" },
        children: [
          {
            path: "/orders/order",
            name: "Orders",
            component: () => import("../views/orders/order/OrdersOrder.vue"),
            meta: { title: "Заказы" },
          },
          {
            path: "/orders/order/detail/:id",
            name: "OrdersOrderDetail",
            component: () =>
              import("../views/orders/order/OrdersOrderDetail.vue"),
            meta: { title: "Заказ" },
            children: [
              {
                path: "/orders/order/detail/cargo/:id",
                name: "OrdersOrderDetailCargo",
                component: () =>
                  import("../views/orders/order/OrdersOrderDetailCargo.vue"),
                meta: { title: "Грузы" },
              },
              {
                path: "/orders/order/detail/comment/:id",
                name: "OrdersOrderDetailComment",
                component: () =>
                  import("../views/orders/order/OrdersOrderDetailComment.vue"),
                meta: { title: "Комментарии" },
              },
              {
                path: "/orders/order/detail/documents/:id",
                name: "OrdersOrderDetailDocument",
                component: () =>
                  import("../views/orders/order/OrdersOrderDetailDocument.vue"),
                meta: { title: "Документы" },
              },
              {
                path: "/orders/order/detail/trip/:id",
                name: "OrdersOrderDetailTrip",
                component: () =>
                  import("../views/orders/order/OrdersOrderDetailTrip.vue"),
                meta: { title: "Рейсы" },
              },
              {
                path: "/orders/order/detail/finance/:id",
                name: "OrdersOrderDetailFinance",
                component: () =>
                  import("../views/orders/order/OrdersOrderDetailFinance.vue"),
                meta: { title: "Финансы" },
              },
              {
                path: "/orders/order/detail/status/:id",
                name: "OrdersOrderDetailStatus",
                component: () =>
                  import("../views/orders/order/OrdersOrderDetailStatus.vue"),
                meta: { title: "Статусы" },
              },
              {
                path: "/orders/order/detail/invoice/:id",
                name: "OrdersOrderDetailInvoice",
                component: () =>
                  import("../views/orders/order/OrdersOrderDetailInvoice.vue"),
                meta: { title: "Счета" },
              },
            ],
          },
        ],
      },
      {
        path: "/order-trip",
        name: "Trips",
        component: () => import("../views/orders/OrdersView.vue"),
        redirect: "/order-trip",
        meta: { title: "Рейсы" },
        children: [
          {
            path: "/order-trip",
            name: "OrderTrips",
            component: () =>
              import("../views/orders/order-trip/OrderTrips.vue"),
            meta: { title: "Рейсы" },
          },
          {
            path: "/orders/trip/detail/:id",
            name: "OrderTripDetail",
            component: () =>
              import("../views/orders/order-trip/OrderTripDetail.vue"),
            meta: { title: "Рейс" },
            children: [
              {
                path: "/order-trip/detail/basic-info/:id",
                name: "OrderTripDetailCargo",
                component: () =>
                  import("../views/orders/order-trip/OrderTripDetailCargo.vue"),
                meta: { title: "Основная информация" },
              },
              {
                path: "/order-trip/detail/document/:id",
                name: "OrderTripDetailDocument",
                component: () =>
                  import(
                    "../views/orders/order-trip/OrderTripDetailDocument.vue"
                  ),
                meta: { title: "Документы" },
              },
            ],
          },
        ],
      },
      {
        path: "/carrier",
        name: "CarriersView",
        component: () => import("../views/carrier/CarriersView.vue"),
        redirect: "/carrier",
        meta: { title: "Перевозчики" },
        children: [
          {
            path: "/carrier",
            name: "CarriersList",
            component: () => import("../views/carrier/CarriersList.vue"),
            meta: { title: "Перевозчики" },
          },
        ],
      },
      {
        path: "/clients",
        name: "ClientsView",
        component: () => import("../views/clients/ClientsView.vue"),
        redirect: "/clients",
        meta: { title: "Клиенты" },
        children: [
          {
            path: "/clients",
            name: "ClientsClient",
            component: () =>
              import("../views/clients/client/ClientsClient.vue"),
            meta: { title: "Клиенты" },
          },
          {
            path: "/client/user/list",
            name: "ClientToUser",
            component: () => import("../views/clients/client/UserToClient.vue"),
            meta: { title: "Пользователи клиентов" },
          },
          {
            path: "/clients/client/detail/:id",
            name: "ClientsClientDetail",
            component: () =>
              import("../views/clients/client/ClientsClientDetail.vue"),
            meta: { title: "Клиент" },
            children: [
              {
                path: "/clients/client/detail/basic-info/:id",
                name: "ClientsClientDetailBasicInfo",
                component: () =>
                  import(
                    "../views/clients/client/ClientsClientDetailBasicInfo.vue"
                  ),
                meta: { title: "Основная информация" },
              },
              {
                path: "/clients/client/detail/direction/:id",
                name: "ClientsClientDetailDirection",
                component: () =>
                  import(
                    "../views/clients/client/ClientsClientDetailDirection.vue"
                  ),
                meta: { title: "Направления" },
              },
              {
                path: "/clients/client/detail/document/:id",
                name: "ClientsClientDetailDocument",
                component: () =>
                  import(
                    "../views/clients/client/ClientsClientDetailDocument.vue"
                  ),
                meta: { title: "Документы" },
              },
              {
                path: "/clients/client/detail/comment/:id",
                name: "ClientsClientDetailComment",
                component: () =>
                  import(
                    "../views/clients/client/ClientsClientDetailComment.vue"
                  ),
                meta: { title: "Комментарии" },
              },
            ],
          },
        ],
      },
      {
        path: "/role/list",
        name: "RoleList",
        component: () => import("../views/role/RoleList.vue"),
        meta: { title: "Роли" },
      },
      {
        path: "/role/log",
        name: "Logs",
        component: () => import("../views/role/LogList.vue"),
        redirect: "/role/log/action-list",
        meta: { title: "Логи" },
        children: [
          {
            path: "/role/log/action-list",
            name: "ActionsView",
            component: () => import("../views/role/subs/logs/ActionsView.vue"),
            meta: { title: "Список действий" },
          },
        ],
      },
      {
        path: "/role/organization",
        name: "Organization",
        component: () => import("../views/role/OrganizationView.vue"),
        redirect: "/role/organization/companies",
        meta: { title: "Организация" },
        children: [
          {
            path: "/role/organization/companies",
            name: "OrganizationCompanies",
            component: () =>
              import(
                "../views/role/subs/organization/OrganizationCompanies.vue"
              ),
            meta: { title: "Компании" },
          },
          {
            path: "/role/organization/departments",
            name: "DepartmentsView",
            component: () =>
              import("../views/role/subs/organization/DepartmentsView.vue"),
            meta: { title: "Отделы" },
          },
          {
            path: "/role/organization/employees",
            name: "EmployeesView",
            component: () =>
              import("../views/role/subs/organization/EmployeesView.vue"),
            meta: { title: "Сотрудники" },
          },
          {
            path: "/role/organization/group-of-employees",
            name: "GroupOfEmployees",
            component: () =>
              import("../views/role/subs/organization/GroupOfEmployees.vue"),
            meta: { title: "Группы сотрудников" },
          },
        ],
      },
      {
        path: "/role/classifiers",
        name: "TemplateList",
        component: () =>
          import("../views/role/subs/templates/TemplateList.vue"),
        redirect: "/role/document/templates/list/service-templates",
        meta: { title: "Шаблоны" },
        children: [
          {
            path: "/role/document/template/invoices",
            name: "InvoicesTemplate",
            component: () =>
              import("../views/role/subs/templates/InvoiceTemplate.vue"),
            meta: { title: "Шаблоны счетов" },
          },
          {
            path: "/role/document/templates/list/service-templates",
            name: "ExpenseTemplate",
            component: () =>
              import("../views/role/subs/templates/ExpenseTemplate.vue"),
            meta: { title: "Шаблоны расходов" },
          },
        ],
      },
      {
        path: "/role/classifiers",
        name: "Classifier",
        component: () => import("../views/role/RoleList.vue"),
        redirect: "/role/classifiers/vat-rates",
        meta: { title: "Справочники" },
        children: [
          {
            path: "/role/classifiers/vat-rates",
            name: "VatRates",
            component: () => import("../views/role/subs/VatRates.vue"),
            meta: { title: "Ставки НДС" },
          },
          {
            path: "/role/classifiers/rail-stations",
            name: "RailStations",
            component: () => import("../views/role/subs/RailStations.vue"),
            meta: { title: "Ж/Д станции" },
          },
          {
            path: "/role/classifiers/banks",
            name: "BankView",
            component: () => import("../views/role/subs/BanksView.vue"),
            meta: { title: "Банки" },
          },
          {
            path: "/role/classifiers/req-statuses",
            name: "RequestStatuses",
            component: () => import("../views/role/subs/ReqStatuses.vue"),
            meta: { title: "Статусы заявок" },
          },
          {
            path: "/role/classifiers/custom-transport-types",
            name: "CustomTransportTypes",
            component: () => import("../views/role/subs/TransportTypes.vue"),
            meta: { title: "Типы транспорта" },
          },
          {
            path: "/role/classifiers/position-of-contact-persons",
            name: "PositionOfContactPersons",
            component: () =>
              import("../views/role/subs/PositionOfContactPersons.vue"),
            meta: { title: "Должности контактных лиц" },
          },
          {
            path: "/role/classifiers/request-purposes",
            name: "ReqPurposes",
            component: () => import("../views/role/subs/ReqPurpose.vue"),
            meta: { title: "Цели заявок" },
          },
          {
            path: "/role/classifiers/request-sources",
            name: "ReqSources",
            component: () => import("../views/role/subs/ReqSources.vue"),
            meta: { title: "Источники заявок" },
          },
          {
            path: "/role/classifiers/order-statuses",
            name: "OrderStatuses",
            component: () => import("../views/role/subs/OrderStatuses.vue"),
            meta: { title: "Статусы заказов" },
          },
          {
            path: "/role/classifiers/trip-statuses",
            name: "TripStatus",
            component: () => import("../views/role/subs/TripStatuses.vue"),
            meta: { title: "Статусы рейсов" },
          },
          {
            path: "/role/classifiers/packagings",
            name: "PackagingsView",
            component: () => import("../views/role/subs/PackagingsView.vue"),
            meta: { title: "Упаковки" },
          },
          {
            path: "/role/classifiers/cargo-statuses",
            name: "CargoStatus",
            component: () => import("../views/role/subs/CargoStatus.vue"),
            meta: { title: "Статусы грузов" },
          },
          {
            path: "/role/classifiers/workers-post",
            name: "WorkersPost",
            component: () => import("../views/role/subs/WorkersPost.vue"),
            meta: { title: "Должности сотрудников" },
          },
          {
            path: "/role/classifiers/auto-pickup",
            name: "AutoPickUp",
            component: () => import("../views/role/subs/AutoPickUp.vue"),
            meta: { title: "Автозабор" },
          },
          {
            path: "/role/classifiers/refusal-reason",
            name: "RefusalReason",
            component: () => import("../views/role/subs/RefusalReason.vue"),
            meta: { title: "Причины отказа" },
          },
          {
            path: "/role/classifiers/country-list",
            name: "CountryView",
            component: () => import("../views/role/subs/CountryView.vue"),
            meta: { title: "Страны" },
          },
          {
            path: "/role/classifiers/city-list",
            name: "CityView",
            component: () => import("../views/role/subs/CityView.vue"),
            meta: { title: "Города" },
          },
          {
            path: "/role/classifiers/products",
            name: "ProductTypes",
            component: () => import("../views/role/subs/ProductTypes.vue"),
            meta: { title: "Типы продуктов" },
          },
          {
            path: "/role/classifiers/client-types",
            name: "ClientType",
            component: () => import("../views/role/subs/ClientType.vue"),
            meta: { title: "Типы клиентов" },
          },
          {
            path: "/role/classifiers/carrier-types",
            name: "CarrierType",
            component: () => import("../views/role/subs/CarrierTypes.vue"),
            meta: { title: "Типы перевозчиков" },
          },
          {
            path: "/role/classifiers/breaking-rule",
            name: "BreakingRule",
            component: () => import("../views/role/subs/BreakingRule.vue"),
            meta: { title: "Правила нарушения" },
          },
          {
            path: "/role/classifiers/payment-term",
            name: "PaymentTerms",
            component: () => import("../views/role/subs/PaymentTerm.vue"),
            meta: { title: "Условия оплаты" },
          },
        ],
      },
      {
        path: "/role/edit/:id",
        name: "RoleEdit",
        component: () => import("../views/role/RoleEdit.vue"),
        meta: { title: "Редактирование роли" },
      },
    ],
  },
  {
    path: "/login",
    name: "LoginView",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/LoginView.vue"),
    meta: { title: "Вход" },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (store.getters.hasLogin === true) {
    if (to.matched.length === 0) {
      from.path
        ? next({
            name: from.name,
          })
        : next("/404");
    } else {
      // Проверка доступа к маршрутам /role и /carrier
      const isRolePath = to.path.indexOf("/role") === 0;
      const isCarrierPath = to.path.indexOf("/carrier") === 0;

      if (isRolePath || isCarrierPath) {
        const isAdmin = store.getters.isAdmin;
        const isSalesHead = store.getters.isSalesHead;

        // Админы имеют полный доступ ко всем /role и /carrier маршрутам
        if (isAdmin) {
          next();
          return;
        }

        // SalesHead имеет доступ только к /role/classifiers
        if (isSalesHead && isRolePath) {
          const isClassifiersPath = to.path.indexOf("/role/classifiers") === 0;
          if (isClassifiersPath) {
            next();
            return;
          }
        }

        // Блокируем доступ для всех остальных случаев
        // Перенаправляем на главную страницу
        next({
          name: "HomeView",
        });
        return;
      }

      next();
    }
    return;
  } else if (to.path.indexOf("/login") == -1) {
    next({
      name: "LoginView",
    });
    return;
  } else {
    next();
    return;
  }
});

router.afterEach((to) => {
  const defaultTitle = "TASU";
  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} | ${defaultTitle}`;
  } else {
    document.title = defaultTitle;
  }
});

export default router;
